import { Box, styled } from '@mui/material';

export const DialogActionsContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(1),
  marginInline: theme.spacing(1),
  marginBottom: theme.spacing(1)
}));
